module.exports = __webpack_public_path__ + "img/icon-send.2b165352.svg";